window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};


const DEFAULT_COOKIE_NAME = '__layout_preferences';
const DEFAULT_PREFERENCES = {
    //schema: (window.matchMedia||window.matchMedia("(prefers-color-scheme: dark)").matches) ? 'dark' : 'default'
    schema: 'default'
};
let CLASS_INSTANCE;



// Ustaw cookie
function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

// Pobierz cookie
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
}

// Zapisz preferencje (JSON → Base64)
function savePreferences(prefs,days=365) {
    try {
        const json = JSON.stringify(prefs);
        const encoded = btoa(json);
        setCookie(DEFAULT_COOKIE_NAME, encoded, days);
    } catch (e) {
        console.error("Błąd zapisu preferencji:", e);
    }
}

// Wczytaj preferencje (Base64 → JSON)
function loadPreferences() {
    const encoded = getCookie(DEFAULT_COOKIE_NAME);
    if (!encoded) return null;
    try {
        return JSON.parse(atob(encoded));
    } catch(e) {
        console.error("Błąd dekodowania cookies:", e);
        return null;
    }
}





// Klasa główna
class ClassPreferencesManager {
    // Konstruktor
  constructor(days = 365) {
    this.days = (days && days>=1 && days<=365) ? days : 30;

    if (!this.getPreference('loaded')) {
        var prefs = DEFAULT_PREFERENCES;
        prefs.loaded = true;
        savePreferences(prefs, this.days);
    }
  }

  // Pobierz aktualne preferencje
  getPreference(key) {
    try {
        return loadPreferences()[key];
    } catch(e) {
        return null;
    }
  }

  // Pobierz aktualne preferencje
  getAllPreferences() {
    try {
        return loadPreferences();
    } catch(e) {
        return {};
    }
  }

  // Zmień konkretną kategorię
  setPreference(key, value) {
    var prefs = loadPreferences() || {}
    prefs[key] = value;
    savePreferences(prefs, this.days);
  }

  // Reset do domyślnych
  resetPreferences() {
    savePreferences(DEFAULT_PREFERENCES, this.days);
  }
};


//Dodanie klasy jako proxy dzięki czemy mozna uzywać window.silesia.layout.preferencesManager.metoda() a nie (new window.silesia.layout.preferencesManager).metoda()
window.silesia.layout.preferencesManager = new Proxy(ClassPreferencesManager, {
  get(target, prop) {
    if (prop in target) return target[prop]; // statyczne zmienne
    // jeżeli nie ma zmiennej statycznej, twórz instancję i odwołaj się do metody
    CLASS_INSTANCE = CLASS_INSTANCE || new target();
    return (...args) => CLASS_INSTANCE[prop](...args);
  }
});